import { render, staticRenderFns } from "./ScreeningProcessBlank.vue?vue&type=template&id=038e85c5&scoped=true&"
import script from "./ScreeningProcessBlank.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessBlank.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningProcessBlank.vue?vue&type=style&index=0&id=038e85c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e85c5",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('038e85c5')) {
      api.createRecord('038e85c5', component.options)
    } else {
      api.reload('038e85c5', component.options)
    }
    module.hot.accept("./ScreeningProcessBlank.vue?vue&type=template&id=038e85c5&scoped=true&", function () {
      api.rerender('038e85c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessBlank.vue"
export default component.exports